import { logout } from "auth/SystemAuth/context/actions";
import {
	useSystemAuthDispatch
} from "auth/SystemAuth/context/context";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { selectAppConfig } from "store/appConfigSlice";
import { saveElementValuesAsync } from "store/rfiSlice";

const GovAppBar = (props: any) => {
  //Hooks
  const location = useLocation();
  const authDispatch = useSystemAuthDispatch();
  const dispatch = useAppDispatch();
  const appConfig = useAppSelector(selectAppConfig);
  const navigate = useNavigate();

  // Handlers
  const onLogout = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    dispatch(saveElementValuesAsync()).finally( () =>{
    logout(authDispatch);
    navigate("/loggedout");
    })
  };

  const onHome = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    navigate("/");
  };

  return (
    <nav
      id="mainNav"
      className="navbar navbar-expand-lg navbar-light bg-white justify-content-between shadow-sm"
    >
      <div>
        <a
          className="navbar-brand d-flex align-items-center mb-0 pt-0"
          href="#"
          onClick={onHome}
        >
          {appConfig?.logo && (
            <img
              className="logo k-mr-2"
              src={`data:image/png;base64,${appConfig?.logo}`}
              alt="application unison"
            />
          )}

          {!appConfig?.logo && (
            <img
              src="/image/logoUnison.svg"
              alt="Unison logo"
              className="logo k-mr-2"
            />
          )}
          <div className="appName">RFI Assistant</div>
        </a>
      </div>
      <div id="navbarNavMain" className="d-lg-block">
        <ul className="navbar-nav ml-auto mt-3 flex-row">
          {!(
            location.pathname.toLowerCase() === "/home" ||
            location.pathname.toLowerCase() === "/"
          ) && (
            <li className="nav-item">
              <a className="nav-link px-2 text-dark" onClick={onHome} href="#">
                Home
              </a>
            </li>
          )}
          <li className="nav-item">
            <a className="nav-link px-2 text-dark" onClick={onLogout} href="#">
              Sign Out
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default GovAppBar;
